import { Injectable } from '@angular/core';
import { IAutoLoanEndpoints, IAutoLoanSettings, ICarzingTokenConfig, IEndpointConfig } from './interfaces/auto-loans.interface';

@Injectable()
export class SettingsService {

    get settings (): IAutoLoanSettings {
      return Object.assign(<IAutoLoanSettings> {
        enableOpt: 'true',
        activeStates: ['ca'],
        protocol: 'https',
        visitedPage: 'updated',
        outOfStateUrl: '/coming-soon-state/',
        turndownUrl: '/thank-you-for-your-submission/',
        endpoint: 'api-dev2.westlakefinancial.com/api',
        baseUrl: "https://api-dev2.westlakefinancial.com/api/",
      }, (<any> window).LCAutoLoanConfig);
    }

    get optimizedEnabled (): boolean {
        try {
            return JSON.parse(this.settings.enableOpt);
        } catch {
        }
        return false;
    }

    get CzTokenConfig (): ICarzingTokenConfig {
        return Object.assign(
            <ICarzingTokenConfig> {
                prefix: 'CzAuth',
                version: 'v1.0.0',
                endpoint: 'api/LoanCenterApi/LoanOffers'
            },
            this.settings.czTokenConfig
        )
    }

    get endpointConfig (): IEndpointConfig {
        let protocol: 'http' | 'https' = 'http';
        let domain = 'betaapi.westlakefinancial.com';
        const pattern = /(https|http):\/\/+(.*)/gm;
        const matches = pattern.exec(this.settings.baseUrl);
        if (matches && matches.length > 1) {
            protocol = <'http' | 'https'> matches[1];
            if (matches.length > 2) {
                domain = matches[2].split('/')[0];
            }
        }
        return {
            domain,
            protocol,
            methods: this.endpoints
        };
    }

    get endpoints (): IAutoLoanEndpoints {
        return Object.assign(<IAutoLoanEndpoints> {
            getVehicles: 'api/LoanCenterApi/vehicles',
            updateOffer: 'api/LoanCenterApi/UpdateLoanOffer',
            getUserDetails: 'api/LoanCenterApi/VelocifyLeadFields',
            closestDealers: 'api/LoanCenterApi/preferreddealers',
            prequalify: 'api/LoanCenterApi/LoanOffers',
            classicYears: 'api/WestlakeApi/GetClassicVehicleYears',
            classicMakes: 'api/WestlakeApi/GetClassicVehicleMakes',
            classicModels: 'api/WestlakeApi/GetClassicVehicleModels',
            uploadAAN: {
                security: null,
                endpoint: 'api/AutoRefinanceApi/UploadAAN',
            },
        }, this.settings.methods)
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/auto-loans/settings.service.ts